<template>
    <div class="product-link">
        <h2 class="subtitle">Subproducts</h2>
        <div>
            <div v-if="productParts.length < 1">
                This product has no subproducts
                <br/>
                <br/>
            </div>
            <div v-for="part in productParts">
                <div class="floater">
                    <div class="float-item">
                        <div class="field" v-if="editingPart === part.id">
                            <p class="control">
                                <input type="number"
                                       min="1"
                                       class="input item-count-input"
                                       :value="part.count"
                                       @input="editPartCount = $event.target.value">
                            </p>
                        </div>
                        <strong v-if="editingPart !== part.id">{{ part.count }} x</strong>
                    </div>
                    <div class="float-item">
                        <div>
                            <router-link :to="{ name: 'product', params: {id: part.product.id}}">
                                {{ part.product.name }}
                            </router-link>
                            <div v-if="editingPart !== part.id">
                                <strong v-if="part.title">{{ part.title }}</strong>
                                <div v-if="part.description">
                                    <em>{{ part.description }}</em>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="float-item">
                        -
                        &nbsp;
                        <span v-if="editingPart !== part.id">
                            <a @click="edit(part)">Edit</a>
                            &nbsp;
                            <a class="delete" @click="remove(part)"></a>
                        </span>
                        <span v-else>
                            <button type="button" class="button is-primary" @click="update(part)">Save</button>
                            <button type="button" class="button" @click="stopEdit()">Cancel</button>
                        </span>
                    </div>
                </div>
                <div v-if="editingPart === part.id">
                    <br/>
                    <div class="field">
                        <label class="label">Title</label>
                        <form-control type="text"
                                      v-model="editPartTitle"
                                      placeholder="title"
                        ></form-control>
                    </div>
                    <div class="field">
                        <label class="label">Description</label>
                        <form-control type="textarea"
                                      v-model="editPartDescription"
                                      placeholder="Description"
                        ></form-control>
                    </div>
                    <div></div>
                </div>
                <br/>
            </div>
        </div>
        <div v-if="!adding">
            <a class="button is-small" @click="adding = true">Add subproduct...</a>
        </div>
        <div v-if="adding">
            <div class="field">
                <p class="control">
                    <label class="label">How many?</label>
                    <input type="number"
                           min="1"
                           class="input item-count-input"
                           :value="newPartCount"
                           @input="newPartCount = $event.target.value">
                    <span class="select inline-select">
                        <select name="item-add" @change="newPartProduct = $event.target.value">
                            <option>Select a product...</option>
                            <option v-for="product in availableProducts" :value="product.id">{{ product.name }}</option>
                        </select>
                    </span>
                    <button type="button" class="button is-primary" @click="add()">Add</button>
                    <button type="button" class="button" @click="adding = false">Cancel</button>
                </p>
            </div>
            <div class="field">
                <p class="control">
                    <label class="label">Title</label>
                    <form-control type="text"
                                  placeholder="title"
                                  v-model="newPartTitle"
                    ></form-control>
                </p>
            </div>
            <div class="field">
                <p class="control">
                    <label class="label">Description</label>
                    <form-control type="textarea"
                                  placeholder="Description"
                                  v-model="newPartDescription"
                    ></form-control>
                </p>
            </div>
        </div>
    </div>
</template>

<style lang="scss" rel="stylesheet/scss">
    .item-count-input {
        display: inline-block;
        width: 75px;
    }

    .inline-select {
        display: inline-block;
        max-width: calc(100% - 80px);
        select {
            max-width: 300px;
        }
    }

    .floater {
        display: flex;
        white-space: nowrap;
    }

    .float-item {
        min-width: 36px;
        white-space: normal;
        &:not(:last-child) {
            margin-right: 1rem;
        }
        &:last-child {
            min-width: 125px;
        }
    }
</style>

<script>
    import {mapGetters} from "vuex"
    import {CREATE_PRODUCT_PART, UPDATE_PRODUCT_PART, DELETE_PRODUCT_PART} from "../../store/mutation-types"
    export default {
        props: ['productId'],
        data() {
            return {
                adding: false,
                newPartCount: 1,
                newPartProduct: null,
                newPartTitle: null,
                newPartDescription: null,
                editingPart: false,
                editPartCount: 1,
                editPartTitle: null,
                editPartDescription: null,
            }
        },
        computed: Object.assign({}, mapGetters(['products']), {
            availableProducts () {
                let parts = this.$store.state.products.product_parts.filter(item => item.product_id === this.productId)
                let ids   = []
                for (let part in parts) {
                    ids.push(parts[part].product_part_id)
                }
                return this.products.filter(item => ids.indexOf(item.id) === -1).sort((a, b) => {
                    return b.id - a.id
                })
            },
            productParts () {
                let parts = this.$store.state.products.product_parts.filter(part => part.product_id === this.productId)
                let ids   = [];
                for (let part in parts) {
                    ids.push(parts[part].product_part_id)
                }

                let products = this.products.filter(product => ids.indexOf(product.id) !== -1)

                return products.map(product => {
                    return Object.assign({}, parts.find(part => part.product_part_id === product.id), {product})
                })
            }
        }),
        methods: {
            edit(part) {
                this.editingPart         = part.id
                this.editPartCount       = part.count
                this.editPartTitle       = part.title
                this.editPartDescription = part.description
            },
            stopEdit() {
                this.editingPart = false
            },
            add() {
                this.$store.dispatch(CREATE_PRODUCT_PART, {
                    product_id: this.productId,
                    product_part_id: this.newPartProduct,
                    count: this.newPartCount,
                    title: this.newPartTitle,
                    description: this.newPartDescription,
                })
                this.adding             = false
                this.editingPart        = false
                this.newPartProduct     = null
                this.newPartCount       = 1
                this.newPartTitle       = null
                this.newPartDescription = null
            },
            update(part) {
                this.$store.dispatch(UPDATE_PRODUCT_PART, {
                    id: part.id,
                    product_id: this.productId,
                    product_part_id: part.product.id,
                    count: this.editPartCount,
                    title: this.editPartTitle,
                    description: this.editPartDescription,
                })
                this.adding              = false
                this.editingPart         = false
                this.editPartCount       = 1
                this.editPartTitle       = null
                this.editPartDescription = null
            },
            remove(part) {
                this.$store.dispatch(DELETE_PRODUCT_PART, {
                    id: part.id,
                    product_id: this.productId,
                    product_part_id: part.id,
                    count: part.count,
                    title: part.title,
                    description: part.description,
                })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ProductParts.vue?46f57586